import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

export class ContentLibraryFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    maxFiles?: number;
    accepts: string;
    headerTooltip?: string;
    uploadButtonIcon?: string;
    buttonLabel: string;
    placeholder?: string;
    required?: boolean;
    validators?: ValidatorFn[];
    defaultValue?: string;
    maxSizeBytes: number;
    fileName: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        {
            description,
            maxFiles = 3,
            accepts,
            headerTooltip,
            uploadButtonIcon = 'fa-regular fa-duotone fa-square-plus',
            buttonLabel = '',
            placeholder,
            required = false,
            validators,
            defaultValue,
            maxSizeBytes,
            fileName
        }: {
            description?: string;
            maxFiles?: number;
            accepts?: string;
            headerTooltip?: string;
            uploadButtonIcon?: string;
            buttonLabel?: string;
            placeholder?: string;
            required?: boolean;
            validators?: ValidatorFn[];
            defaultValue?: string;
            maxSizeBytes?: number;
            fileName?: string;
        } = {}
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.maxFiles = maxFiles;
        this.accepts = accepts;
        this.headerTooltip = headerTooltip;
        this.uploadButtonIcon = uploadButtonIcon;
        this.buttonLabel = buttonLabel;
        this.placeholder = placeholder;
        this.required = required;
        this.validators = validators;
        this.defaultValue = defaultValue;
        this.maxSizeBytes = maxSizeBytes;
        this.fileName = fileName;
    }
}
